export default __webpack_public_path__ + "locales/bg/Payments.json?hash=6bc058a1188d7b8b9d03e2768c679320";